import { useContext, useEffect } from "react";
import { Link } from "uikit-react";
import { AppContexts } from "../../../providers";
import { useHistory, useLocation } from "react-router-dom";

const defaultValue = [
  { types: ["branding", "destination"], path: "branding", key: "branding" },
  { types: ["inbox"], path: "messages", key: "messages" },
  { types: ["accessories"], path: "extras", key: "extras" },
  { types: ["chat"], path: "chat", key: "chat" },
  { types: ["guestbook"], path: "guestbook", key: "guestbook" },
  {
    types: ["destination", "destination_tabs"],
    path: "destination-guide",
    key: "destination",
  },
  { types: ["integrations"], path: "integrations", key: "integrations" },
  { types: ["five_star"], path: "five-star", key: "five_star" },
  { types: ["tags"], path: "tags", key: "tags" },
  { types: ["destination"], path: "embed", key: "embed" },
  {
    types: ["holiday_schedule"],
    path: "holiday-schedule",
    key: "holiday_schedule",
  },
  { types: ["integration", "custom_macros"], path: "api", key: "api" },
  { types: [], path: "smart-locks", key: "smart_locks" },
];

const SettingsNavbar = () => {
  const { get, active, setActive } = useContext(AppContexts.SettingsContext);
  const { user: account } = useContext(AppContexts.AuthContext);
  const history = useHistory();
  const location = useLocation();

  const handleActiveList = (key) => {
    let val = defaultValue.find((v) => v.key === key);

    setActive(key);
    get(val.types);
    history.push(`/settings/${val.path}`);
  };

  const hasExtras = () => {
    return (account?.details?.product || "").split(",").includes("extras");
  };

  const hasFlag = (flag) => {
    return !!account.flags.find((f) => f.name === flag);
  };

  useEffect(() => {
    let pathArray = history.location.pathname.split("/");
    let path = pathArray.pop().replace("#", "");
    let val = defaultValue.find((v) => v.path === path);

    if (!val) {
      setActive(defaultValue[0].key);
      get(defaultValue[0].types);
    } else {
      setActive(val.key);
      get(val.types);
    }
  }, [location.pathname]);

  return (
    <aside className="hms-section-nav-wrap uk-width-auto">
      <ul className="hms-section-nav">
        <li
          className={active === "branding" ? "is-active" : ""}
          onClick={() => handleActiveList("branding")}
        >
          <Link>Branding</Link>
        </li>
        <li
          className={active === "guestbook" ? "is-active" : ""}
          onClick={() => handleActiveList("guestbook")}
        >
          <Link>Guest Guides</Link>
        </li>
        <li
          className={active === "messages" ? "is-active" : ""}
          onClick={() => handleActiveList("messages")}
        >
          <Link>Messaging</Link>
        </li>
        {hasExtras() && (
          <li
            className={active === "extras" ? "is-active" : ""}
            onClick={() => handleActiveList("extras")}
          >
            <Link>Extras Guide</Link>
          </li>
        )}
        <li
          className={active === "destination" ? "is-active" : ""}
          onClick={() => handleActiveList("destination")}
        >
          <Link>Area Guide</Link>
        </li>
        <li
          className={active === "chat" ? "is-active" : ""}
          onClick={() => handleActiveList("chat")}
        >
          <Link>AI Chatbot & Text Webchat</Link>
        </li>
        {hasFlag("airbnb-active") && (
          <li
            className={active === "integrations" ? "is-active" : ""}
            onClick={() => handleActiveList("integrations")}
          >
            <Link>Airbnb Integration</Link>
          </li>
        )}
        <li
          className={active === "tags" ? "is-active" : ""}
          onClick={() => handleActiveList("tags")}
        >
          <Link>Tags</Link>
        </li>
        <li
          className={active === "five_star" ? "is-active" : ""}
          onClick={() => handleActiveList("five_star")}
        >
          <Link>Five Star Review</Link>
        </li>
        {/*
        <li
          className={active === "holiday_schedule" ? "is-active" : ""}
          onClick={() => handleActiveList("holiday_schedule")}
        >
          <Link>Holiday Schedule</Link>
        </li>
        <li
          className={active === "embed" ? "is-active" : ""}
          onClick={() => handleActiveList("embed")}
        >
          <Link>Embed</Link>
        </li>
         */}
        <li
          className={active === "smart_locks" ? "is-active" : ""}
          onClick={() => handleActiveList("smart_locks")}
        >
          <Link>Smart Locks</Link>
        </li>
        <li
          className={active === "api" ? "is-active" : ""}
          onClick={() => handleActiveList("api")}
        >
          <Link>API</Link>
        </li>
      </ul>
    </aside>
  );
};

export default SettingsNavbar;
